<template>
  <SideMenuLayout title="Statistiques" :items="items">
    <template #controls>
      <div v-if="usesMetric" class="control">
        <span class="control-label">Chiffre d'affaires</span>
        <div class="segmented">
          <button v-for="metric in metrics" :key="metric.value" type="button" class="segment" :class="{active: state.metric === metric.value}"
                  @click="state.metric = metric.value">{{ metric.label }}</button>
        </div>
      </div>
      <div class="control">
        <span class="control-label">Découpage</span>
        <div class="segmented">
          <button v-for="granularity in granularities" :key="granularity.value" type="button" class="segment" :class="{active: state.granularity === granularity.value}"
                  @click="state.granularity = granularity.value">{{ granularity.label }}</button>
        </div>
      </div>
      <div class="control">
        <span class="control-label">Période</span>
        <select class="field" :value="state.preset ?? ''" @change="selectPreset($event.target.value)">
          <option value="" disabled>Personnalisée</option>
          <option v-for="preset in presets" :key="preset.key" :value="preset.key">{{ preset.label }}</option>
        </select>
      </div>
      <div class="control dates">
        <label class="date-row"><span class="control-label">Du</span>
          <input class="field" type="date" :value="state.start" :max="state.end" aria-label="Début de la période" @change="setDates($event.target.value, state.end)" />
        </label>
        <label class="date-row"><span class="control-label">Au</span>
          <input class="field" type="date" :value="state.end" :min="state.start" aria-label="Fin de la période" @change="setDates(state.start, $event.target.value)" />
        </label>
      </div>
    </template>
    <slot/>
  </SideMenuLayout>
</template>

<script>
import {GRANULARITIES, METRICS, PERIOD_PRESETS, StatisticsService} from "@/statistics/services/StatisticsService";
import SideMenuLayout from "@/components/SideMenuLayout.vue";

const TABS = [
  {to: '/statistics', label: 'Synthèse', icon: 'grid'},
  {to: '/statistics/clients', label: 'Clients', icon: 'users'},
  {to: '/statistics/quotes', label: 'Devis', icon: 'file'},
  {to: '/statistics/invoices', label: 'Factures', icon: 'receipt'},
  {to: '/statistics/collections', label: 'Encaissements', icon: 'wallet'},
];

/**
 * Menu latéral des statistiques et réglages communs à toutes les rubriques : période, découpage et chiffre d'affaires (facturé ou encaissé).
 */
export default {
  name: 'StatisticsHeader',
  components: {SideMenuLayout},
  data() {
    return {tabs: TABS, granularities: GRANULARITIES, metrics: METRICS, presets: PERIOD_PRESETS};
  },
  computed: {
    items() {
      return this.tabs.map(tab => ({...tab, active: this.$route.path === tab.to}));
    },
    state() {
      return StatisticsService.data;
    },
    usesMetric() {
      return !!this.$route.meta.usesMetric;
    },
  },
  created() {
    StatisticsService.init();
  },
  methods: {
    selectPreset(key) {
      StatisticsService.applyPreset(key);
    },
    setDates(start, end) {
      StatisticsService.setDates(start, end);
    },
  },
};
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl'

.control
  display flex
  flex-direction column
  gap 6px

  &.dates
    gap 8px

.date-row
  display flex
  align-items center
  gap 8px

  .control-label
    width 24px

  .field
    flex 1
    min-width 0

.control-label
  font-size 12px
  font-weight 600
  color CTRL_TEXT_MUTED
  white-space nowrap

.field
  height 34px
  padding 0 10px
  font-size 13px
  color CTRL_TEXT
  background white
  border 1px solid CTRL_BORDER
  border-radius CTRL_RADIUS_SM
  transition border-color CTRL_EASE, background CTRL_EASE

  &:hover
    background CTRL_BG_HOVER
    border-color CTRL_BORDER_HOVER

  &:focus
    outline none
    background CTRL_BG_FOCUS
    border-color CTRL_FOCUS
    box-shadow 0 0 0 3px CTRL_FOCUS_RING

.segmented
  display flex
  padding 3px
  background white
  border 1px solid CTRL_BORDER
  border-radius CTRL_RADIUS

.segment
  flex 1
  height 28px
  padding 0 6px
  font-size 12.5px
  font-weight 600
  color CTRL_TEXT_MUTED
  background transparent
  border none
  border-radius 7px
  cursor pointer
  transition background CTRL_EASE, color CTRL_EASE

  &:hover:not(.active)
    color THEME_COLOR_PRIMARY

  &.active
    color white
    background THEME_COLOR_PRIMARY
</style>
